import { twMerge } from "tailwind-merge";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Loader from "./Loader";

export interface ModalProps {
  children?: React.ReactNode;
  open: boolean;
  title?: string;
  height?: string;
  width?: string;
  isLoading?: boolean;
  onClose: (event?: React.MouseEvent) => void;
}

export default function Modal({
  open,
  children,
  title,
  isLoading = false,
  height = "600px",
  width = "600px",
  onClose,
}: ModalProps) {
  if (!open) {
    return null;
  }

  return (
    <div
      className={twMerge(
        "fixed inset-0 z-[999] h-screen w-screen items-center justify-center",
        open && "fixed flex bg-black/85"
      )}
    >
      <div
        className="flex max-h-screen flex-col rounded-lg bg-white px-8 py-10"
        style={{ height, maxHeight: height, width }}
      >
        <div className="mb-5 flex items-center justify-between">
          <p className="text-2xl font-bold">{title}</p>
          <XMarkIcon
            className="h-6 w-6 cursor-pointer hover:text-zinc-500"
            onClick={onClose}
          />
        </div>
        {isLoading ? (
          <Loader />
        ) : (
          <div className="flex h-full w-full flex-col overflow-hidden">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
